module.exports = __webpack_public_path__ + "img/6c7526a.jpg";